import { errorMessage, post } from '../../lib/api';
import { ReasonDialog, useToast } from '../../ui/feedback';

export type CancelTarget = { kind: 'item' | 'order'; id: string; label: string };

/** O pedido inteiro pode ser cancelado em qualquer etapa antes da entrega (recebido, em preparo, pronto). */
export const canCancelOrder = (status: string) => status !== 'DELIVERED' && status !== 'CANCELLED';

/** Confirmação com motivo obrigatório (vai para o histórico e para o aviso impresso da cozinha/bar). */
export function CancelDialog({ target, onClose, onDone }: { target: CancelTarget | null; onClose: () => void; onDone: () => Promise<unknown> }) {
  const toast = useToast();
  const isOrder = target?.kind === 'order';
  return (
    <ReasonDialog
      open={!!target}
      onClose={onClose}
      title={isOrder ? 'Cancelar pedido' : 'Cancelar item'}
      description={
        isOrder ? (
          <>Cancelar o <strong>{target?.label}</strong>? Os itens ainda não entregues saem da conta da mesa, a cozinha/bar é avisada e o estoque (se controlado) é devolvido.</>
        ) : (
          <>Cancelar <strong>{target?.label}</strong>? O valor sai da conta da mesa e o estoque (se controlado) é devolvido.</>
        )
      }
      confirmLabel={isOrder ? 'Cancelar pedido' : 'Cancelar item'}
      tone="danger"
      onConfirm={async (reason) => {
        try {
          await post(isOrder ? `/api/staff/orders/${target!.id}/cancel` : `/api/staff/order-items/${target!.id}/cancel`, { reason });
          await onDone();
          toast.success(isOrder ? 'Pedido cancelado' : 'Item cancelado');
        } catch (e) {
          throw new Error(errorMessage(e));
        }
      }}
    />
  );
}
